import React from 'react';
import { Button } from '../ui/button';
import { ArrowLeft, TrendingUp, TrendingDown } from 'lucide-react';

const StockHeader = ({ stock, onBack }) => (
  <div className="flex items-center justify-between" data-testid="stock-header">
    <div className="flex items-center gap-4">
      <Button variant="ghost" onClick={onBack} className="hover:bg-gray-100" data-testid="stock-back-btn">
        <ArrowLeft size={20} />
      </Button>
      <div>
        <h1 className="text-3xl font-bold text-gray-900">{stock.symbol}</h1>
        <p className="text-gray-600">{stock.name}</p>
      </div>
    </div>
    <div className="text-right">
      <p className="text-3xl font-bold text-gray-900">${stock.price.toFixed(2)}</p>
      <div className="flex items-center gap-2 justify-end">
        {stock.change >= 0 ? (
          <TrendingUp className="text-green-600" size={20} />
        ) : (
          <TrendingDown className="text-red-600" size={20} />
        )}
        <span className={`text-lg font-semibold ${stock.change >= 0 ? 'text-green-600' : 'text-red-600'}`}>
          {stock.change >= 0 ? '+' : ''}
          {stock.change.toFixed(2)} ({stock.changePercent >= 0 ? '+' : ''}
          {stock.changePercent.toFixed(2)}%)
        </span>
      </div>
    </div>
  </div>
);

export default StockHeader;
